import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/sites/wpspotlight.pro/src/components/Affiliate/Affiliate.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/sites/wpspotlight.pro/src/components/global/animation-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/sites/wpspotlight.pro/src/components/pricing-cards.tsx");
